<template>
  <div>
    <b-button variant="outline-success" v-b-modal.modal-prevent-closing-events
      >Создать ивент</b-button
    >
    <b-modal
      centered
      id="modal-prevent-closing-events"
      ref="modal"
      title="Группа"
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleOk"
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group
          label="Название"
          label-for="email-input"
          invalid-feedback="Заполните название!"
          :state="modalState"
        >
          <b-form-input type="text" v-model="name"></b-form-input>
        </b-form-group>
        <b-form-group
          label="Дата"
          label-for="password-input"
          invalid-feedback="Укажите дату!"
          :state="modalState"
        >
          <b-form-input type="date" v-model="date"></b-form-input>
        </b-form-group>
        <b-form-group
          label="Время"
          label-for="password-input"
          invalid-feedback="Укажите время!"
          :state="modalState"
        >
          <b-form-input type="time" v-model="time"></b-form-input>
        </b-form-group>
      </form>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import { mapActions } from "vuex";
export default {
  name: "EventCreator",
  data: function () {
    return {
      modalState: null,
      name: null,
      date: null,
      time: null,
      group: null,
    };
  },
  methods: {
    ...mapActions(["logOutUser"]),
    resetModal() {
      for (let field in this.admin) {
        this.admin[`${field}`] = null;
      }
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      this.handleSubmit();
    },
    async handleSubmit() {
      let payload = {
        name: this.name,
        date: this.date,
        time: this.time,
        club_id: this.$cookie.get("club_id"),
      };
      const config = {
        headers: {
          Authorization: `Bearer ${this.$cookie.get("access_token")}`,
        },
      };
      await axios
        .post(`${process.env.VUE_APP_API}/schedule/create`, payload, config)
        .then((response) => {
          console.log(response.data);
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.logOutUser();
          } else {
            alert(error.response.data);
          }
        });
      // this.$emit('refresh')
      window.location.reload();
      this.$nextTick(() => {
        this.$bvModal.hide("modal-prevent-closing-events");
      });
    },
  },
};
</script>

<style scoped></style>
